import { reviews } from "@/mocks/homeData";
import SectionHeader from "./SectionHeader";

const values = [
  { icon: "ri-refresh-line", title: "持续更新", desc: "表情包日更、壁纸周更，永远有新鲜瓜" },
  { icon: "ri-focus-3-line", title: "分类清晰", desc: "按类型分块，找表情不费劲" },
  { icon: "ri-vip-crown-2-line", title: "版权友好", desc: "个人存图自用随意，商用需沟通授权" },
  { icon: "ri-user-heart-line", title: "欢迎投稿", desc: "原创与私藏好物，被采用即标注出处" },
];

function Stars({ n }: { n: number }) {
  return (
    <span className="flex items-center gap-0.5 text-secondary-600">
      {Array.from({ length: 5 }).map((_, i) => (
        <i key={i} className={`${i < n ? "ri-star-fill" : "ri-star-line"} text-sm`} />
      ))}
    </span>
  );
}

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeader
          align="center"
          eyebrow="关于 52 吃瓜"
          title="一颗把快乐种满瓜田的站点"
          desc="52吃瓜是一群资深吃瓜群众运营的表情素材图鉴站。我们相信，会吃瓜、会玩梗的人，聊天从来不冷场。"
        />

        {/* 价值理念 */}
        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((v) => (
            <div
              key={v.title}
              className="rounded-2xl border border-background-200/70 bg-background-50 p-5 transition-transform hover:-translate-y-1"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-accent-100 text-accent-600">
                <i className={`${v.icon} text-2xl`} />
              </span>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{v.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
            </div>
          ))}
        </div>

        {/* 内容原则 */}
        <div className="mt-10 grid grid-cols-1 items-center gap-8 overflow-hidden rounded-3xl bg-background-50 p-6 lg:grid-cols-2 md:p-8">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
              <i className="ri-flag-2-line" /> 内容原则
            </span>
            <h3 className="mt-3 font-heading text-2xl text-foreground-950">
              坚持「有梗、真实、不添乱」
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              每一套表情包、每一张沙雕图都经过筛选，宁可少一点，也不放无聊的充数内容。
              关注网络热梗动态，紧跟当下的表达方式，同时过滤低俗与恶意玩梗，让你玩得开心也玩得安心。
            </p>
            <a
              href="mailto:hello@52chigua.cn"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-send-plane-line" /> 投稿与合作
            </a>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="rounded-2xl bg-accent-100 p-5">
              <p className="font-heading text-3xl text-accent-700">日更</p>
              <p className="mt-1 text-xs text-foreground-600">表情包沙雕图梗图每日上新</p>
            </div>
            <div className="rounded-2xl bg-secondary-100 p-5">
              <p className="font-heading text-3xl text-secondary-700">周更</p>
              <p className="mt-1 text-xs text-foreground-600">头像壁纸周边每周集中更新</p>
            </div>
            <div className="rounded-2xl bg-primary-100 p-5">
              <p className="font-heading text-3xl text-primary-600">0 广</p>
              <p className="mt-1 text-xs text-foreground-600">少打扰，把空间留给内容本身</p>
            </div>
            <div className="rounded-2xl bg-background-200 p-5">
              <p className="font-heading text-3xl text-foreground-800">12w+</p>
              <p className="mt-1 text-xs text-foreground-600">累计上架表情素材持续增长</p>
            </div>
          </div>
        </div>

        {/* 用户口碑 */}
        <div className="mt-10">
          <div className="flex items-center justify-between">
            <h3 className="font-heading text-xl text-foreground-950 md:text-2xl">在瓜田里的口碑</h3>
            <span className="flex items-center gap-1 rounded-full bg-background-50 px-3 py-1 text-sm text-foreground-700">
              <Stars n={5} /> 4.8 综合好评
            </span>
          </div>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {reviews.map((r) => (
              <figure
                key={r.name}
                className="flex flex-col justify-between rounded-2xl border border-background-200/70 bg-background-50 p-5"
              >
                <blockquote className="text-sm leading-relaxed text-foreground-700">“{r.text}”</blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-200 font-heading text-accent-800">
                    {r.name.charAt(0)}
                  </span>
                  <span className="min-w-0">
                    <span className="block truncate text-sm font-semibold text-foreground-900">{r.name}</span>
                    <span className="block text-xs text-foreground-400">{r.role}</span>
                  </span>
                  <span className="ml-auto"><Stars n={r.rating} /></span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}